// utils/timesheetExport.js
import * as XLSX from 'xlsx';
import dayjs from 'dayjs';

export const exportToExcel = (timesheets, formatWeekDisplay, getAttendanceIcon) => {
  if (!timesheets || timesheets.length === 0) {
    return;
  }

  const formatTime = (date) => {
    if (!date) return "";
    return dayjs(date).format("HH:mm");
  };

  // Prepare data for export
  const exportData = timesheets.map((ts, index) => {
    const row = {
      '#': index + 1,
      'Employee': ts.employeeId?.name || 'N/A',
      'Employee ID': ts.employeeId?.employeeId || 'N/A',
      'Week': formatWeekDisplay(ts.weekStartDate, ts.weekEndDate),
      'Regular Hours': ts.totalRegularHours,
      'Overtime Hours': ts.totalOvertimeHours,
      'Status': ts.status?.toUpperCase() || 'DRAFT',
    };

    // Add day columns
    const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    dayNames.forEach((dayName, dayIdx) => {
      const entry = ts.dailyEntries?.find(
        (e) => dayjs(e.date).day() === (dayIdx === 6 ? 0 : dayIdx + 1)
      );
      
      if (entry) {
        const punchIn = formatTime(entry.punchInDateTime);
        const punchOut = formatTime(entry.punchOutDateTime);
        row[dayName] = `${punchIn} - ${punchOut}`;
      } else {
        row[dayName] = '-';
      }
    });

    return row;
  });

  // Create worksheet
  const ws = XLSX.utils.json_to_sheet(exportData);

  // Set column widths
  const colWidths = [
    { wch: 5 },   // #
    { wch: 20 },  // Employee
    { wch: 15 },  // Employee ID
    { wch: 20 },  // Week
    { wch: 12 },  // Mon
    { wch: 12 },  // Tue
    { wch: 12 },  // Wed
    { wch: 12 },  // Thu
    { wch: 12 },  // Fri
    { wch: 12 },  // Sat
    { wch: 12 },  // Sun
    { wch: 12 },  // Regular Hours
    { wch: 12 },  // Overtime Hours
    { wch: 12 },  // Status
  ];
  ws['!cols'] = colWidths;

  // Create workbook
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Timesheets');

  // Generate filename with current date
  const fileName = `timesheets_${dayjs().format('YYYY-MM-DD_HH-mm')}.xlsx`;

  // Save file
  XLSX.writeFile(wb, fileName);
};